import template from './item-template.html';
import controller from './item-template.controller';

let itemTemplateComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default itemTemplateComponent;
